import { Component } from '@theme/component';

class CustomCursorComponent extends Component {
  #posX = 0;
  #posY = 0;
  #mouseX = 0;
  #mouseY = 0;
  #easing = 4;
  #rafId = 0;
  /** @type {MediaQueryList | null} */
  #pointerQuery = null;

  connectedCallback() {
    super.connectedCallback();
    // Track the pointer type live (not just once at load) so the cursor turns on
    // when a mouse becomes available — e.g. after leaving mobile/touch emulation.
    this.#pointerQuery = window.matchMedia('(pointer: fine)');
    this.#pointerQuery.addEventListener('change', this.#syncPointer, { signal: this.abortController.signal });
    this.#syncPointer();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('mousemove', this.#handleMouseMove);
    if (this.#rafId) {
      cancelAnimationFrame(this.#rafId);
      this.#rafId = 0;
    }
  }

  /** Attach mouse tracking only while a fine pointer (mouse) is the active input. */
  #syncPointer = () => {
    document.removeEventListener('mousemove', this.#handleMouseMove);
    if (this.#pointerQuery?.matches) {
      document.addEventListener('mousemove', this.#handleMouseMove);
    } else {
      this.deactivate();
    }
  };

  #handleMouseMove = (event) => {
    this.#mouseX = event.clientX;
    this.#mouseY = event.clientY;
    if (!this.classList.contains('active') || this.#rafId) return;
    this.#rafId = requestAnimationFrame(this.#animate);
  };

  #animate = () => {
    this.#rafId = 0;
    this.#posX += (this.#mouseX - this.#posX) / this.#easing;
    this.#posY += (this.#mouseY - this.#posY) / this.#easing;
    this.style.setProperty('--cursor-x', `${this.#posX}px`);
    this.style.setProperty('--cursor-y', `${this.#posY}px`);
    if (this.classList.contains('active')) {
      this.#rafId = requestAnimationFrame(this.#animate);
    }
  };

  activate() {
    if (!this.#pointerQuery?.matches) return;
    this.#posX = this.#mouseX;
    this.#posY = this.#mouseY;
    this.classList.add('active');
    if (!this.#rafId) this.#rafId = requestAnimationFrame(this.#animate);
  }

  deactivate() {
    this.classList.remove('active', 'pressed');
  }

  press() {
    this.classList.add('pressed');
  }

  release() {
    this.classList.remove('pressed');
  }
}

if (!customElements.get('custom-cursor')) {
  customElements.define('custom-cursor', CustomCursorComponent);
}
